import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/apiClient";
import MyCar from "../MyCar";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import "../../style/AllCarsAdmin.css";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import Fuse from "fuse.js";

const PAGE_SIZE = 30;

function MakeModelFilter({
  marcas,
  modelos,
  marca,
  modelo,
  onMarcaChange,
  onModeloChange,
}) {
  return (
    <div className="makemodel-filter">
      <select
        className="mm-select"
        value={marca}
        onChange={onMarcaChange}
        aria-label="Filtrar por marca"
      >
        <option value="">Marca</option>
        {marcas.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
      <select
        className="mm-select"
        value={modelo}
        onChange={onModeloChange}
        disabled={!marca}
        aria-label="Filtrar por modelo"
      >
        <option value="">Modelo</option>
        {modelos.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </div>
  );
}

function AllCarsAdmin() {
  const [carros, setCarros] = useState([]);
  const [, setventas] = useState([]);
  const [invVendidos ,setinvVendido] = useState(0)
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [, setSuccessMessage] = useState("");
  const { authToken, logout } = useAuth();
  const [selectedBrand, setSelectedBrand] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [fullmarca, setfullmarca] = useState([]);
  const [, setSuggestingModels] = useState(false);
  const [suggestions, setsugestions] = useState([]);
  const [input, setInput] = useState("");
  const [searchType, setSearchType] = useState([]);
  const [username, setUsername] = useState('');
  const [invAct, setinvAct] = useState(0);
  const [invTot, setinvTot] = useState(0);
  const [usrLenght, setUsrLenght] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [, setfullmodelo] = useState([]);
  const [allmodelos, setAllModelos] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filterMarca, setFilterMarca] = useState("");
  const [filterModelo, setFilterModelo] = useState("");
  const [filterModelos, setFilterModelos] = useState([]);
  const sentinelRef = useRef(null);
  const listContainerRef = useRef(null);
  const currentFilterRef = useRef(null);
  const offFilterRef = useRef(0);
  // Bumped by every list-replacing fetch; next-page fetchers capture it and
  // discard late responses so switching filters mid-append can't mix the old
  // filter's page into the new list.
  const fetchGenRef = useRef(0);



  const navigate = useNavigate();

  const clearMakeModel = () => {
    setFilterMarca("");
    setFilterModelo("");
    setFilterModelos([]);
  };

  const resetAllFilters = () => {
    clearMakeModel();
    setIsChecked(false);
    setIsChecked2(false);
    setIsChecked3(false);
  };

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
    }
  };

  const fetchFirstPage = async () => {
    fetchGenRef.current += 1;
    setLoading(true);
    setIsFiltered(false);
    resetAllFilters();
    currentFilterRef.current = null;
    offFilterRef.current = 0;
    setHasMore(true);
    try {
      const res = await api.get("findspecial/paginated/0");
      setCarros(res.data.carros);
      setHasMore(res.data.hasMore);
      setOffset(PAGE_SIZE);
      setError(null);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data");
      setCarros([]);
      setHasMore(false);
    }
    setLoading(false);
  };

  const fetchFilterFirstPage = async ({ method, endpoint, body }) => {
    fetchGenRef.current += 1;
    setLoading(true);
    setIsFiltered(true);
    setHasMore(true);
    setCarros([]);
    currentFilterRef.current = { method, endpoint, body };
    offFilterRef.current = 0;
    try {
      const url = `${endpoint}?offset=0&limit=${PAGE_SIZE}`;
      const res = method === "post" ? await api.post(url, body) : await api.get(url);
      const list = res.data.carros || [];
      setCarros(list);
      setHasMore(Boolean(res.data.hasMore));
      offFilterRef.current = list.length;
      setError(null);
    } catch (err) {
      console.error(err);
      setCarros([]);
      setHasMore(false);
    }
    setLoading(false);
  };

  const fetchFilterNextPage = async () => {
    if (!hasMore || !currentFilterRef.current || loading) return;
    setLoadingMore(true);
    const gen = fetchGenRef.current;
    const { method, endpoint, body } = currentFilterRef.current;
    try {
      const url = `${endpoint}?offset=${offFilterRef.current}&limit=${PAGE_SIZE}`;
      const res = method === "post" ? await api.post(url, body) : await api.get(url);
      if (gen !== fetchGenRef.current) {
        setLoadingMore(false);
        return; // a first-page fetch superseded this filter
      }
      const list = res.data.carros || [];
      setCarros((prev) => [...prev, ...list]);
      setHasMore(Boolean(res.data.hasMore));
      offFilterRef.current += list.length || PAGE_SIZE;
    } catch (err) {
      console.error("Error fetching more filtered data:", err);
    }
    setLoadingMore(false);
  };

  const fetchNextPage = async () => {
    if (!hasMore || loadingMore || loading) return;
    if (isFiltered) {
      return fetchFilterNextPage();
    }
    setLoadingMore(true);
    const gen = fetchGenRef.current;
    try {
      const res = await api.get(
        `findspecial/paginated/${offset}`
      );
      if (gen !== fetchGenRef.current) {
        setLoadingMore(false);
        return; // a first-page fetch superseded this listing
      }
      setCarros((prev) => [...prev, ...res.data.carros]);
      setHasMore(res.data.hasMore);
      setOffset((prev) => prev + PAGE_SIZE);
    } catch (err) {
      console.error("Error fetching more data:", err);
    }
    setLoadingMore(false);
  };

  const findnuevos = () => fetchFilterFirstPage({
    method: "get",
    endpoint: "findspecial/nuevoingreso",
  });

  const findvendidos = () => fetchFilterFirstPage({
    method: "get",
    endpoint: "ventas/vendidos",
  });

  // ---- Make / Model dependent dropdown filters ----
  const getFilterModelos = async (marcaID) => {
    try {
      const res = await api.post("marcasymodelos/modelobymarca", {
        marca: marcaID,
      });
      const list = Array.isArray(res.data) ? res.data : [];
      setFilterModelos(list.map((m) => m.Nombre));
    } catch (error) {
      console.error("Error fetching modelos by marca:", error);
      setFilterModelos([]);
    }
  };

  // Make, Model and "En Oferta" stack into a single filter/Admin query.
  const runCombinedFilter = (marca, modelo, offerta) => {
    const body = {};
    if (marca) body.marca = marca;
    if (modelo) body.modelo = modelo;
    if (offerta) body.offerta = true;
    if (Object.keys(body).length === 0) {
      fetchFirstPage();
      return;
    }
    // browse active inventory: match the default list and the stat counts
    body.vendido = false;
    body.hidden = false;
    fetchFilterFirstPage({
      method: "post",
      endpoint: "filter/Admin",
      body,
    });
  };

  const handleMarcaFilterChange = (event) => {
    const marca = event.target.value;
    setFilterMarca(marca);
    setFilterModelo("");
    setFilterModelos([]);
    // make/model + oferta combine; Nuevos/Vendido and text search do not
    setIsChecked2(false);
    setIsChecked3(false);
    setInput("");
    setsugestions([]);
    if (marca) {
      const marcaObj = findObjectByKeyValue(fullmarca, "Nombre", marca);
      if (marcaObj) {
        getFilterModelos(marcaObj._id);
      }
    }
    runCombinedFilter(marca, "", isChecked);
  };

  const handleModeloFilterChange = (event) => {
    const modelo = event.target.value;
    setFilterModelo(modelo);
    runCombinedFilter(filterMarca, modelo, isChecked);
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    // oferta stacks on top of the current make/model selection
    setIsChecked2(false);
    setIsChecked3(false);
    runCombinedFilter(filterMarca, filterModelo, checked);
  };

  const handleCheckboxChange2 = (event) => {
    const checked = event.target.checked;
    setIsChecked2(checked);
    if (checked) {
      setIsChecked(false);
      setIsChecked3(false);
      clearMakeModel();
      findnuevos();
    } else {
      fetchFirstPage();
    }
  };

  const handleCheckboxChange3 = (event) => {
    const checked = event.target.checked;
    setIsChecked3(checked);
    if (checked) {
      setIsChecked(false);
      setIsChecked2(false);
      clearMakeModel();
      findvendidos();
    } else {
      fetchFirstPage();
    }
  };

  //todo esto es del searchbar
  function capitalizeFirstLetter(str) {
    if (!str) return str; // Return the original string if it's empty or undefined
    if(str === "bmw"){
      return "BMW"
    }
    if(str === "gmc"){
      return "GMC"
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const getMarcas = async () => {
    try {
      const res = await api.get("marcasymodelos/marca");
      const list = Array.isArray(res.data) ? res.data : [];
      setMarcas(list.map((c) => c.Nombre));
      setfullmarca(list);
    } catch (error) {
      console.error("Error fetching marcas:", error);
    }
  };

  const getmodelos = async (marcaID) => {
    try {
      const data = { marca: marcaID };
      const res = await api.post("marcasymodelos/modelobymarca", data);
      const list = Array.isArray(res.data) ? res.data : [];
      const nombres = list.map((m) => m.Nombre);
      const nombresConMarca = list.map(
        (modelo) => `${selectedBrand} ${modelo.Nombre}`
      );
      setModelos(nombres);
      setsugestions(nombresConMarca);
      setSuggestingModels(true);
    } catch (error) {
      console.error("Error fetching modelos by marca:", error);
    }
  };

  const fuse = new Fuse(marcas, {
    threshold: 0.6, // Adjust this value to be more or less strict
    keys: ["marca"],
  });

  const fusemodelos = new Fuse(allmodelos, {
    threshold: 0.6, // Adjust this value to be more or less strict
    keys: ["modelo"],
  });

  const anioPattern = /^\d{4}$/;

  const findObjectByKeyValue = (array, key, value) => {
    return array.find((obj) => obj[key] === value);
  };

  const lotNumberPattern = /^\d{8}$/

  const detectInputType = (value) => {
    setSelectedBrand("");
    const valueTrim = value.trim();
    let parts = valueTrim.split(" ");
    let matches = [];
    const suggestions = fuse.search(parts[0]);
    const suggestionsmodelos = fusemodelos.search(parts[0])
    let mergedArray = suggestionsmodelos.concat(suggestions);
    setsugestions(mergedArray.map((suggestion) => suggestion.item));
    parts.forEach((part) => {
      if(part === "mercedes"){
        matches.push({ type: "marca", value: "Mercedes Benz" });
      }
      if(part === "santa"){
        matches.push({ type: "modelo", value: "Santa Fe" });
      }
      if(part === "Santa"){
        matches.push({ type: "modelo", value: "Santa Fe" });
      }
      if(part === "Mercedes"){
        matches.push({ type: "marca", value: "Mercedes Benz" });
      }
      if (marcas.some((marca) => marca.toLowerCase() === part.toLowerCase())) {
        matches.push({ type: "marca", value: capitalizeFirstLetter(part) });
      }
      if (allmodelos.some((modelo) => modelo.toLowerCase() === part.toLowerCase())) {
        matches.push({ type: "modelo", value: capitalizeFirstLetter(part) });
      }
      if (
        modelos.some((modelo) => modelo.toLowerCase() === part.toLowerCase())
      ) {
        matches.push({ type: "modelo", value: capitalizeFirstLetter(part) });
      }
      if (anioPattern.test(part)) {
        matches.push({ type: "anio", value: part });
      }
      if (lotNumberPattern.test(part)) {
        matches.push({ type: "lote", value: part });
      }
    });
    if (matches.length === 0) {
      matches.push({ type: "unknown", value: value }); // Fallback if no matches found
    }
    if (matches[0].type === "marca") {
      const algo = findObjectByKeyValue(fullmarca, "Nombre", matches[0].value);
      setSelectedBrand(matches[0].value);
      getmodelos(algo._id);
    }
    setSearchType([...new Set(matches)]);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setInput(value);
    detectInputType(value);
  };

  const fetchCarrosType = async () => {
    resetAllFilters();
    const combinedJson = searchType.reduce((accumulator, current) => {
      accumulator[current.type] = current.value;
      return accumulator;
    }, {});
    return fetchFilterFirstPage({
      method: "post",
      endpoint: "filter/Admin",
      body: combinedJson,
    });
  };

  const navigateToResults = () => {
    fetchCarrosType();
  };

  const handleSearch = () => {
    navigateToResults();
  };

  const detectInputTypeSugestion = (value) => {
    const valueTrim = value.trim();
    let parts = valueTrim.split(" ");
    let matches = [];
    parts.forEach((part) => {
      if(part === "mercedes"){
        matches.push({ type: "marca", value: "Mercedes Benz" });
      }
      if(part === "santa"){
        matches.push({ type: "modelo", value: "Santa Fe" });
      }
      if(part === "Santa"){
        matches.push({ type: "modelo", value: "Santa Fe" });
      }
      if(part === "Mercedes"){
        matches.push({ type: "marca", value: "Mercedes Benz" });
      }
      if (marcas.some((marca) => marca.toLowerCase() === part.toLowerCase())) {
        matches.push({ type: "marca", value: capitalizeFirstLetter(part) });
      }
      if (allmodelos.some((modelo) => modelo.toLowerCase() === part.toLowerCase())) {
        matches.push({ type: "modelo", value: capitalizeFirstLetter(part) });
      }
      if (
        modelos.some((modelo) => modelo.toLowerCase() === part.toLowerCase())
      ) {
        matches.push({ type: "modelo", value: capitalizeFirstLetter(part) });
      }
      if (anioPattern.test(part)) {
        matches.push({ type: "anio", value: part });
      }
      if (lotNumberPattern.test(part)) {
        matches.push({ type: "lote", value: part });
      }
    });
    if (matches.length === 0) {
      matches.push({ type: "unknown", value: value }); // Fallback if no matches found
    }
    setSearchType([...new Set(matches)]);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion);
    setsugestions([]);
    detectInputTypeSugestion(suggestion);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const getModelosAll = async () => {
    const res = await api.get("marcasymodelos/modelo");
    const modelos = res.data;
    const nombres = modelos.map((modelo) => modelo.Nombre);
    setAllModelos(nombres)
    setfullmodelo(modelos);
  };

  const fetchStats = async () => {
    try {
      const [countsRes, usersRes, ventasRes] = await Promise.all([
        api.get("findspecial/counts"),
        api.get("usuario"),
        api.get("ventas/"),
      ]);
      setUsrLenght(usersRes.data.length);
      setventas(ventasRes.data.reverse());
      setinvAct(countsRes.data.active);
      setinvVendido(countsRes.data.sold);
      setinvTot(countsRes.data.total);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  useEffect(() => {
    const inicio = async () => {
      if (!authToken) {
        navigate("/");
      }
      getuser();
    };
    inicio();
    fetchFirstPage();
    fetchStats();
    getMarcas();
    getModelosAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!hasMore || loadingMore || loading) return;
    const node = sentinelRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          fetchNextPage();
        }
      },
      {
        root: listContainerRef.current || null,
        rootMargin: "200px",
      }
    );
    observer.observe(node);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, hasMore, loadingMore, isFiltered, loading]);

  const handleCarDeleted = async () => {
    await fetchFirstPage();
    fetchStats();
  };


  const handleCarAdded = () => {
    setSuccessMessage("Carro agregado exitosamente");
    setTimeout(() => {
      setSuccessMessage("");
    }, 3000); // El mensaje desaparece después de 3 segundos
    handleCarDeleted(); // Actualizar la lista de carros
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
        <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
          <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Listado de Autos</p>
            <div className="status">
              <div className="user-status">
                <p className="status-title">Inventario Activo</p>
                <p className="status-property">{invAct}</p>
              </div>
              <div className="user-status">
                <p className="status-title">Inventario Vendido</p>
                <p className="status-property">{invVendidos}</p>
              </div>
              <div className="user-status">
                <p className="status-title">Inventario Total</p>
                <p className="status-property">{invTot}</p>
              </div>
              <div className="user-status">
                <p className="status-title">Usuarios Totales</p>
                <p className="status-property">{usrLenght}</p>
              </div>
            </div>
            <div className="search-bar-a">
              <div
                className={`search-bar-ac ${
                  suggestions.length > 0 ? "show-suggestions" : ""
                }`}
              >
                <input
                  type="text"
                  id="Search"
                  value={input}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown} // Detectar Enter
                  placeholder=" Marca, modelo, lote, etc."
                />
                {suggestions.length > 0 && (
                  <ul className="suggestions-list-mod">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => handleSuggestionClick(suggestion)}
                        className="suggestion-item"
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <MakeModelFilter
                marcas={marcas}
                modelos={filterModelos}
                marca={filterMarca}
                modelo={filterModelo}
                onMarcaChange={handleMarcaFilterChange}
                onModeloChange={handleModeloFilterChange}
              />
              <div className="filter-container">
                <label htmlFor="filtro1" className="filter-label">
                  <input
                    type="checkbox"
                    id="filtro1"
                    className="filter-checkbox"
                    checked={isChecked2}
                    onChange={handleCheckboxChange2}
                  />
                  Nuevos
                </label>
                <label htmlFor="filtro2" className="filter-label">
                  <input
                    type="checkbox"
                    id="filtro2"
                    className="filter-checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  En Oferta
                </label>
                <label htmlFor="filtro3" className="filter-label">
                  <input
                    type="checkbox"
                    id="filtro3"
                    checked={isChecked3}
                    onChange={handleCheckboxChange3}
                    className="filter-checkbox"
                  />
                  Vendido
                </label>
              </div>
              <button type="submit" id="search" onClick={handleSearch}>
                BUSCAR
              </button>
            </div>
            <div className="search-bar-a-movil">
              <div
                className={`search-bar-ac ${
                  suggestions.length > 0 ? "show-suggestions" : ""
                }`}
              >
                <input
                  type="text"
                  id="Search-m"
                  value={input}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown} // Detectar Enter
                  placeholder=" Marca, modelo, lote, etc."
                />
                {suggestions.length > 0 && (
                  <ul className="suggestions-list-m">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => handleSuggestionClick(suggestion)}
                        className="suggestion-item-m"
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <MakeModelFilter
                marcas={marcas}
                modelos={filterModelos}
                marca={filterMarca}
                modelo={filterModelo}
                onMarcaChange={handleMarcaFilterChange}
                onModeloChange={handleModeloFilterChange}
              />
              <div className="filter-container">
                <label htmlFor="filtro1-m" className="filter-label">
                  <input
                    type="checkbox"
                    id="filtro1-m"
                    className="filter-checkbox"
                    checked={isChecked2}
                    onChange={handleCheckboxChange2}
                  />
                  Nuevos
                </label>
                <label htmlFor="filtro2-m" className="filter-label">
                  <input
                    type="checkbox"
                    id="filtro2-m"
                    className="filter-checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  En Oferta
                </label>
                <label htmlFor="filtro3-m" className="filter-label">
                  <input
                    type="checkbox"
                    id="filtro3-m"
                    className="filter-checkbox"
                    checked={isChecked3}
                    onChange={handleCheckboxChange3}
                  />
                  Vendido
                </label>
              </div>
              <button type="submit" id="search-m" onClick={handleSearch}>
                BUSCAR
              </button>
            </div>
            <div className="overview-container-admin" ref={listContainerRef}>
              {carros.map((carro) => (
                <div className="overview-item-boletin" key={carro._id}>
                  <MyCar
                    carro={carro}
                    onCarDeleted={handleCarDeleted}
                    onCarAdded={handleCarAdded}
                  />
                </div>
              ))}
              {hasMore && (
                <div ref={sentinelRef} className="scroll-sentinel" />
              )}
              {loadingMore && (
                <div className="loading-more">Cargando más autos...</div>
              )}
              {!hasMore && carros.length > 0 && (
                <div className="end-of-list">No hay más autos</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default AllCarsAdmin;
